import * as api from '../../lib/api';
import _ from 'lodash';

export function fetchAll() {
  return async (dispatch) => {
    let blueprints = await api.invoke({path: '/blueprints'});
    dispatch({
      type: 'BLUEPRINTS__UPDATE_LIST',
      blueprints: blueprints,
    });
    return blueprints;
  };
}

export function fetch({groupId, blueprintId}) {
  return async (dispatch, getState) => {
    let source = await api.invoke(
        {path: `/blueprints/${groupId}/${blueprintId}`});
    if (!source) {
      return null;
    }

    dispatch({
      type: 'BLUEPRINTS__SET_CURRENT',
      blueprint: source,
    });

    return source;
  };
}

export function submit() {
  return async (dispatch, getState) => {
    let blueprint = getState().blueprints.current || {};
    let response = await api.invoke({
      path: `/blueprints/${blueprint.groupId}/${blueprint.blueprintId}`,
      method: 'PUT',
      body: blueprint,
    });
    return response;
  };
}

export function updateCurrentValues(data) {
  return {
    type: 'BLUEPRINTS__UPDATE_CURRENT_VALUES',
    data,
  };
}

export function updateCurrentAudit(audit) {
  return {
    type: 'BLUEPRINTS__UPDATE_CURRENT_AUDIT',
    audit,
  };
}


// WEBPACK FOOTER //
// ./src/store/actions/blueprints.js